import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-05d2bc41"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "cd-slot" };
const _hoisted_2 = { class: "cd-slot__container" };
const _hoisted_3 = { class: "cd-slot__header" };
const _hoisted_4 = ["src"];
const _hoisted_5 = { class: "cd-slot__header__status" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1));
const _hoisted_7 = { class: "cd-slot__name" };
const _hoisted_8 = {
    key: 0,
    class: "cd-slot__date"
};
const _hoisted_9 = { class: "cd-slot__footer" };
const _hoisted_10 = { class: "cd-slot__container" };
import router from '@/router';
import { formatDate } from '@/utilities/formatters';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CustomerDistributionSlot',
    props: {
        slotModel: {}
    },
    setup(__props) {
        const props = __props;
        const edit = () => {
            router.push({
                name: 'CustomerDistributionEdit',
                params: {
                    id: props.slotModel?.id,
                },
            });
        };
        return (_ctx, _cache) => {
            const _component_el_popover = _resolveComponent("el-popover");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("img", {
                            class: "icon cd-slot__header__icon",
                            src: require(`@/assets/img/icons/user-customer-distribution.svg`)
                        }, null, 8, _hoisted_4),
                        _createVNode(_component_el_popover, {
                            trigger: "hover",
                            placement: "right",
                            width: 260
                        }, {
                            reference: _withCtx(() => [
                                _createElementVNode("span", _hoisted_5, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('customer-distribution.list.tooltip.title')) + " ", 1),
                                    _hoisted_6
                                ])
                            ]),
                            default: _withCtx(() => [
                                _createElementVNode("p", null, _toDisplayString(_ctx.$t('customer-distribution.list.tooltip.description')), 1)
                            ]),
                            _: 1
                        })
                    ]),
                    _createElementVNode("strong", _hoisted_7, _toDisplayString(_ctx.slotModel.name), 1),
                    (_ctx.slotModel.createdAt)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('customer-distribution.list.date')) + " " + _toDisplayString(_unref(formatDate)(_ctx.slotModel.createdAt, 'DD MMM YYYY')), 1))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", {
                            class: "cd-slot__footer__edit",
                            onClick: edit
                        }, _toDisplayString(_ctx.$t('customer-distribution.list.btn')), 1)
                    ])
                ])
            ]));
        };
    }
});
